var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLightbulbOn = function SvgLightbulbOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M350 84c16.801 0 28-11.199 28-28V28c0-16.801-11.199-28-28-28s-28 11.199-28 28v28c0 16.801 11.199 28 28 28zM212.8 142.8c11.199-11.199 11.199-28 0-39.199l-22.402-22.402c-11.199-11.199-28-11.199-39.199 0s-11.199 28 0 39.199L170.801 140c16.801 16.801 36.398 5.602 42 2.8zM126 252H98c-16.801 0-28 11.199-28 28s11.199 28 28 28h28c16.801 0 28-11.199 28-28s-11.199-28-28-28zM602 252h-28c-16.801 0-28 11.199-28 28s11.199 28 28 28h28c16.801 0 28-11.199 28-28s-11.199-28-28-28zM548.8 81.199c-11.199-11.199-28-11.199-39.199 0l-19.602 19.602c-11.199 11.199-11.199 28 0 39.199 5.602 5.602 22.398 14 39.199 0l19.602-19.602c11.199-8.398 11.199-28 0-39.199zM350 112c-92.398 0-168 75.602-168 168 0 61.602 33.602 114.8 84 145.6v50.398c0 47.602 36.398 84 84 84s84-36.398 84-84V425.6c50.398-30.801 84-84 84-145.6 0-92.398-75.602-168-168-168zm44.801 271.6c-11.199 5.602-16.801 14-16.801 25.199v67.199c0 16.801-11.199 28-28 28s-28-11.199-28-28v-67.199c0-11.199-5.602-22.398-16.801-25.199C263.199 363.998 238 324.799 238 280c0-61.602 50.398-112 112-112s112 50.398 112 112c0 44.801-25.199 84-67.199 103.6z"
  })));
};

export default SvgLightbulbOn;